import { trackingConstants } from '@frontend/sports/tracking/feature';

export enum BetBuilderTrackingValues {
    BetBuilder = 'betbuilder',
    BetBuilderEventList = 'bet builder event list',
    BuildaBet = 'build a bet',
    BuildaBetButton = 'build a bet button',
    BuildaBetPod = 'build a bet market pod',
    Click = 'click',
    Close = 'close',
    CloseParlay = 'close parlay',
    Coupon = 'coupons / parlay',
    EditPickButton = 'edit pick button',
    EventDetails = 'event details',
    EventDetailsMedia = 'event details media',
    EventInfo = 'event info',
    EventInfoPopup = 'event info popup',
    GoToBetslip = 'go to betslip',
    HowTo = 'how to',
    HowToInfoPopup = 'how to info popup',
    KeepPicks = 'keep picks',
    Load = 'load',
    MarketBoardButton = 'market board button',
    PreCreated = 'pre created option',
    ProductIcon = 'product icon',
    Tab = 'tab',
    QuickBetslip = 'quick betslip',
    WarningPopup = 'warning popup',
    EmbeddedSource = 'SGP embedded',
    OverlaySource = 'SGP overlay',
    OverlaySubNaviagtion = 'SGP overlay - sub navigation',
    InfoRibbon = 'SGP info ribbon',
    InfoDialog = 'SGP info',
    FindOutMore = 'find out more link',
    OkGotItCta = 'ok got it cta',
    LearnMoreCta = 'learn more cta',
    BetBarBadge = 'sgp',
    BetBarPlusBadge = 'sgp+',
    AngstromSgp = 'Angstrom SGP',
    InHouseFootball = 'InHouseBYB',
    InHouseFootballSgpEmbedded = 'InHouseBYB SGP embedded',
    InHouseFootballSgpOverlay = 'InHouseBYB SGP overlay',
    InHouseFootballSgpEventDetails = 'InHouseBYB SGP EventDetails',
    InHouseFootballSgpTopEvents = 'InHouseBYB SGP TopEvents',
    AngstromSgpEmbedded = 'Angstrom SGP embedded',
    AngstromSgpOverlay = 'Angstrom SGP overlay',
    AngstromSgpEventDetails = 'Angstrom SGP EventDetails',
    AngstromSgpTopEvents = 'Angstrom SGP TopEvents',
    SportcastSgpEmbedded = 'Sportcast SGP embedded',
    SportcastSgpOverlay = 'Sportcast SGP overlay',
    UncombinableSelections = "selections can't be combined",
}

export interface TrackBetBuilderSwitcherClick {
    [trackingConstants.COMPONENT_CATEGORY_EVENT]: string | undefined;
    [trackingConstants.COMPONENT_LABEL_EVENT]: string | undefined;
    [trackingConstants.COMPONENT_ACTION_EVENT]: string | undefined;
    [trackingConstants.COMPONENT_POSITION_EVENT]: string | undefined;
    [trackingConstants.COMPONENT_LOCATION_EVENT]: string | undefined;
    [trackingConstants.COMPONENT_EVENT_DETAILS]: string | undefined;
    [trackingConstants.COMPONENT_URL_CLICKED]: string | undefined;
    [trackingConstants.SPORT_ID]: string | undefined;
    [trackingConstants.SPORT_LEAGUE_ID]: string | undefined;
}
